<app-header-one></app-header-one>
<app-banner></app-banner>
<app-about></app-about>
<app-service></app-service>
<app-video></app-video>
<!-- <app-features></app-features>
<app-whyus></app-whyus>
<app-facts></app-facts> 
<app-team></app-team> -->
<app-skills></app-skills>
<app-testimonials></app-testimonials>
<app-blogpost></app-blogpost>
<app-footer [layout]="classname" [logo]="ftlogo" [shape]="ftshape" [shape2]="ftshape2" [shapeclass]="ftshapeclass"
    [shape2class]="ftshape2class"></app-footer>